import { GridCellProps } from '@progress/kendo-react-grid';
import { SHToolTip } from 'app/components/SHToolTip';
import styled from 'styled-components';

type Props = {
    className?: string;
    e: GridCellProps;
    title: string;
    onClick?: (e) => void;
    isCenter?: boolean;
};

const DynamicTitleCell = ({ className, e, title, onClick, isCenter }: Props) => {
    return (
        <td style={e.style}
            className={`${e.className} ${className ?? ''}`} onClick={onClick}>
            <SHToolTip position="top">
                <ContactWrapper title={title} isCenter={isCenter}>
                    {title}
                </ContactWrapper>
            </SHToolTip>
        </td>
    );
};

export default DynamicTitleCell;

const ContactWrapper = styled.div<{ isCenter?: boolean }>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.6;
  min-height: 40px;
  padding:${props => props.isCenter ? '6px 0' : '0'};
`;

